export default {
    consol_type: "Consol type",
    deviation_reason: "Reason for deviation",
    cfo: "CFR",
    brunch: "Branch",
    chat: "Chat",
    ChatRoomEdit: "Create a group chat",
    Notifications: "Notifications",
    StimulReport: "Report",
    airports: "Airports",
    auto: "Vehicles",
    balance_payment_accounts: "Balance of bank accounts",
    banks: "Banks",
    business_operation: "Business operation",
    business_process: "Business process",
    business_process_template: "Templates of business processes",
    capital_accounts: "Financial accounts",
    capital_transfers: "Accounting entry",
    capital_transfers_rur: "Re-evaluation",
    city: "Cities",
    class_access_docs: "Permitting docs",
    class_access_docs_type: "Types of permitting docs",
    class_danger: "Danger classes",
    classification: "Classification catalog",
    client_gtds_by_years: "Customs Declarations report by Customs Houses",
    counting_of_loading_units: "Cargo units counter",
    combiner_all_units: "Console cargoes",
    combiner_all_units_all: "Console cargoes (all)",
    combiner_all_units_archive: "Console cargoes (archive)",
    combiner_all_units_current: "Console cargoes (current)",
    combiner_operations: "Transportation of console cargoes",
    combiner_remains: "Cargo consolidation",
    company: "Counterparties",
    company_crm_doc_number_mask: "Inquiry numbers templates",
    conact_persons: "Contacts",
    contracts: "Contracts register",
    contracts_current: "Contracts register (in progress)",
    contracts_archive: "Contracts register (archive)",
    contracts_all: "Contracts register (all)",
    contracts_addition: "Contracts supplementary agreements register",
    contracts_addition_type: "Contracts supplementary agreements types",
    contracts_fea: "Foreign trade contracts",
    contracts_fea_all: "Foreign trade contracts (all)",
    contracts_fea_archive: "Foreign trade contracts (archive)",
    contracts_fea_current: "Foreign trade contracts (in progress)",
    contracts_fea_addition: "Additional agreement",
    contracts_type: "Contract types",
    country: "Countries",
    country_regions: "Regions",
    couriers: "Couriers",
    cost_price_report: "Сost price",
    article_report: "Report by article",
    crm: "Inquiries",
    crm_all: "Inquiries (all)",
    crm_archive: "Inquiries (archive)",
    crm_current: "Inquiries (in progress)",
    crm_production: "Products",
    curs_eurobank: "Currency rates Euro",
    curs_internal: "Exchange rates",
    delivery_conditions: "Incoterms",
    department: "Departments",
    dislocation: "Dislocation log",
    rolis_event: "Rolis events",
    rolis_subscription: "Rolis subscription",
    rolis_edi: "Rolis EDI",
    doc_operation_type: "Types of documentary operations",
    document_management_doc_type: "Types of documents",
    document_management_incoming: "Incoming",
    document_management_outgoing: "Outgoing",
    document_type: "Document type",
    drivers: "Drivers",
    effex_events_unit: "Events Effex",
    etsng: "ETSNG",
    events: "Events",
    fin_operation: "Quotes",
    fin_operation_buy: "Fin. operation purchase",
    fin_operation_buy_eastex: "Fin. operation purchase",
    fin_operation_group_unit: "Package",
    fin_operation_sale: "Fin. operation sale",
    fin_operation_sale_eastex: "Fin. operation sale",
    gng: "Russial rail code",
    group_operation: "Console cargoes",
    gtd_result_returning_otp_status: "Statuses of results of verifications by Customs",
    gtd_additional_check_status: "Statuses of decisions of additional verifications",
    gtd_all: "All customs Declaration",
    gtd_archive: "GD's in the archive",
    gtd_balance: "Balance of foreign trade contracts",
    gtd_clients_by_years: "Customs Decl report by Consignees",
    gtd_current: "Currents GD's",
    gtd_fact_type: "Types of declarations",
    gtd_payments: "Balance of customs payments",
    check_customs_payments: "Check for non-displayed customs payments",
    gtd_post_customs: "Post-customs clearance control",
    gtds_goods: "Products in Customs Decl.",
    hook: "Hooks",
    inspectors: "Inspectors",
    invoice_incoming: "Incoming invoices",
    invoice_incoming_money: "Incoming cash",
    invoice_outgoing: "Outgoing invoices",
    invoice_outgoing_doc_number_mask: "Templates of invoice numbers",
    invoice_outgoing_money: "Cash expenses",
    leads: "Leads",
    list_documents: "Documents",
    list_feacc_article: "Articles",
    list_feacc_article_all: "Articles (all)",
    list_feacc_article_archive: "Articles (archive)",
    list_feacc_article_current: "Articles (in progress)",
    list_feacc_gtd: "Goods in Customs Decl.",
    list_gtd_post_customs_control: "Refunds after additional verification",
    list_vat: "VAT",
    logistas_unit: "Cargoes",
    manufacturer: "Manufacturers",
    model_auto: "Vehicle brands",
    moved_orders_positions: "Merchandising",
    name_weight: "Cargo names",
    noty_table: "Notifications",
    operation_air: "Aviation operations",
    operation_auto: "Trucking",
    operation_cargo_status_ex_t1: "The status of the cargo EX/T1",
    operation_customs: "Customs",
    operation_detail: "Detailing of operation",
    operation_documentation: "Documentary operation",
    operation_forward: "Port forwarding",
    operation_other: "Other operations",
    operation_packing_unit_type: "Units",
    operation_rate_expense_category: "Service item category",
    operation_custom_status_type: "B/L status",
    operation_rate_expense_include: "Detailing of service item",
    operation_rate_expense_type: "Service item",
    operation_repacking: "Reloading",
    operation_sea: "Bookings",
    operation_sub_doc_auto_menu: "Trucking",
    operation_auto_submenu: "Auto operations",
    operation_sub_doc_auto: "ТТН/CMR",
    operation_sub_doc_auto_current: "ТТН/CMR (in progress)",
    operation_sub_doc_auto_all: "ТТН/CMR (all)",
    operation_sub_doc_auto_archive: "ТТН/CMR (archive)",
    auto_transportation: "Automobile transportations",
    auto_transportation_current: "Automobile transportations (in progress)",
    auto_transportation_archive: "Automobile transportations (archive)",
    auto_transportation_all: "Automobile transportations (all)",
    operation_sub_doc_forward: "Inspections",
    operation_sub_doc_sea: "Bills of lading",
    operation_sub_doc_train: "Railway",
    operation_sub_doc_train_current: "Railway (in progress)",
    operation_sub_doc_train_all: "Railway (all)",
    operation_sub_doc_train_archive: "Railway (archive)",
    operation_train: "Railway operations",
    operation_type: "Types of operations",
    operation_unit: "Cargo units",
    operation_unit_all: "Cargo units (all)",
    operation_unit_archive: "Cargo units (archive)",
    operation_unit_current: "Cargo units (in progress)",
    operation_unit_division: "Type of cargo unit",
    order_doc_number_mask: "Templates of order numbers",
    order_docs_scheme: "Templates of documentary schemes",
    order_request: "Templates of logistics schemes",
    order_units_by_years:
        "Profitability by deals (groupped by type of transport)",
    order_profit_by_operation_type_by_years:
        "Profitability by deals (groupped by type)",
    orders: "Orders",
    orders_all: "Orders (all)",
    orders_archive: "Orders (archive)",
    orders_current: "Orders (in progress)",
    owner_unit: "Export traffic",
    own_rolling_stock_unit: "Own rolling stock",
    own_rolling_stock_unit_current: "Own rolling stock current",
    own_rolling_stock_unit_archive: "Own rolling stock archive",
    own_rolling_stock_unit_all: "Own rolling stock all",
    part_number: "Invoices",
    part_number_prepare_declaration: "Preparation of declarations",
    payment_orders: "Payments",
    payments_by_bank: "Statement of profit and loss (Advanced)",
    payments_gtd_link: "Customs payments",
    payments_incoming: "Incoming payment orders",
    payments_incoming_swift: "Recieved SWIFT",
    payments_incoming_cash: "Recieved cash",
    payments_outgoing: "Outgoing payment orders",
    payments_outgoing_swift: "Paid SWIFT",
    payments_outgoing_cash: "Paid cash",
    permission: "Access rights",
    person_posts: "Positions",
    positions_in_orders_all: "Specifications",
    railways: "Railroads",
    rate_expenses: "Quotes",
    rate_expenses_type: "Services nomenclature",
    report_capital_balance: "Balance",
    report_capital_turnover: "Turnover sheet",
    request_auto: "Auto transportation request",
    request_currency_translation: "Currency transfers",
    request_forward: "Forwarding request",
    request_sea: "Request for marine transportation",
    request_train: "Request for rolling stock",
    requests: "Requests",
    sea_rates: "Sea quotes",
    settings: "Settings",
    tasks: "Tasks",
    tasks_current: "Tasks (in process)",
    tasks_archive: "Task (archive)",
    tasks_all: "Tasks (all)",
    tnved: "HS",
    tp_els: "Customs payments plan",
    train_current: "Trains (in progress)",
    train_archive: "Trains (archive)",
    train_all: "Trains (all)",
    train_number_mask: "Templates of train numbers",
    transfer_points: "Route points",
    type_unit: "Units",
    unit_type_carriage: "Carriage types",
    unit_type_containers: "Container types",
    unit_type_van: "Vehicle body types",
    user_task_theme: "Tasks templates",
    users: "User accounts",
    vessel: "Vessels",
    weight_group: "Group of products",
    work_instructions: "Work instructions",
    credit_late_invoices: "Accounts payable",
    debit_late_invoices: "Receivables",
    client_payment_balance: "Balance with Customer",
    crm_request_status: "Status of inquiry",
    request_status_crm: "The status of the request",
    request_gtd: "Application for Customs Clearance",
    part_number_position: "Customs analytics",
    company_crm_event_type: "CRM events type",
    list_contact_persons_email_broadcast_config: "Documents mailing",
    document_status: "Status of docs",
    template_invoice_post: "Templates of expenses",
    template_invoice: "Template of expence",
    order_notifications: "Order mailing",
    auto_rates: "Auto quotes",
    sea_port_expenses: "Port local costs",
    commercial_offer: "Commercial offers",
    order_profit_by_general: "Financial result",
    person_to_notify: "Notify Party",
    storage_rates: "Storage Rates",
    supermarket_type: "Retailers",
    capital_conversion_operation: "Currency exchange operations",
    prepayment_report: "Report on advances",
    list_company_groups: "Groups of counterparties",
    list_company_category: "Category of counterparty",
    list_company_category_group: "Category group",
    criteria: "Criteria of counterparties",
    work_instructions_document: "Documents of instructions",
    work_instructions_category: "Category of instructions",
    capital_operation_form: "Transactions for forms",
    gtd_units_report: "Customs Decl. Continental",
    docs_send_method: "Way of document dispatch",
    payment_orders_incoming_doc_number_mask:
        "Templates of numbers for cash reciepts",
    payment_orders_outgoing_doc_number_mask:
        "Templates of numbers for cash paid",
    profit_report: "Income report",
    late_invoices_without_unaccounted_report: "Receivables (to be counted)",
    prepare_declaration: "Preparation of Customs Declaration",
    counterparty_balance_report: "Balance with Counterparties",
    dynamic_journals: "Client logs",
    product: "Job Solution",
    move_type: "Move type",
    biz_scope: "BizScope",
    ctrl: "Ctrl/non-ctrl",
    bl_type: "BL type",
    Заказы: "Orders",
    Грузы: "Cargo units",
    Морские: "Sea",
    Капитал: "Capital",
    Железнодорожные: "Train",
    Экспедирование: "Forwarding",
    Документооборот: "Document",
    Декларирование: "Declaration",
    finance: "Finance",
    Аналитика: "Analytics",
    "Финансовые отчеты": "Financial reports",
    "Отчеты по ДТ": "Customs clearance reports",
    "Оперативные отчеты": "Operational reports",
    "Сводные отчеты": "Consolidated reports",
    "Отчеты по клиентам": "Client reports",
    Справочники: "Reference",
    list_reusable: "The list of reusable packaging",
    list_reusable_containers: "Reusable containers",
    settings_finance: "Options (Finance)",
    "Кредиторская задолженность": "Accounts payable",
    "Дебиторская задолженность": "Receivables",
    "Неперевыставленные затраты": "Neprevyshenie costs",
    "Финансовый результат": "The financial result",
    "Акт сверки": "The reconciliation report",
    Отчеты: "Reports",
    templates: "Templates",
    types_classes: "Types, classes",
    geographic_features: "Geographic features",
    foreign_trade_contracts: "Foreign trade contracts",
    quotes: "Quotes",
    "Статусы запроса": "The status of the request",
    "Статусы документов": "Document statuses",
    "Статусы решений по доп.проверке":
        "The status of decisions on additional verification",
    "Статусы результатов проверок из ОТП":
        "The status of audit results from the TNA",
    "Категория контрагента": "Category of counterparty",
    "Группа категорий": "Category group",
    nomenclature_to_print: "Service items for printouts",
    payment_orders_expence_type: "Type of expenses",
    payment_orders_group_expence_type: "Group of expenses",
    payment_orders_subgroup_expence_type: "Subgroup of expenses",
    template_notification_mailing_doc: "Templates for docs mailing",
    template_notification_mailing: "Templates for notifications mailing",
    class_access_docs_type_count_44:
        "Name, information of the permitting document (column 44)",
    batch_fin_operation_buy: "Batch purchase fin. operations",
    report_settings: "Reports settings",
    logos_lang_translation: "Translate Logos",
    icb_office: "ICB Offices",
    payable_cso: "Payable CSO",
    doc_fin_operation_buy: "Fin. operations purchase docs",
    doc_fin_operation_sale: "Fin. operations sale docs",
    manager_bonus: "Manager bonuses",
    invoice_outgoin_money_params: "Params cash paid",
    financial_result_report: "Financial result new",
    courier: "Courier",
    alta_cbx_data: "СВХ",
    alta_cbx_data_all: "Parties (all)",
    alta_cbx_data_current: "Parties (in progress)",
    alta_cbx_data_archive: "Parties (archive)",
    train_menu: "Trains",
    list_contracts: "Contracts",
    contracts_application: "Contracts supplementary agreements",
    industry: "Industries",
    risk_class: "Risk classes",
    crm_request_type: "Requests sources",
    list_ownership_type: "Types of ownership",
    export_units_report_choose: "Export traffic report",
    receivables_report: "Cash flow",
    capital_transfer_template: "Templates of accounting entries",
    capital_expenses: "Income/Expenses",
    list_gtd_notifications: "Mailing by route points",
    operation_sub_doc_air: "Aviation documents",
    operation_sub_doc_customs: "Customs clearance documents",
    operation_sub_doc_repacking: "Documents of the repacking",
    service_combination: "Service combination",
    purchasing_document_report: "Generating reports in the FCS",
    ghq_activity: "GHQ Activity",
    preliminary_gtd_status: "Preliminary GTD status",
    template_payment_schedule: "Templates of payment schedule",
    payment_schedule: "Payment schedule",
    branch_yunas: "Branch Yunas",
    data_changes_log_yunas: "Load XML Yunas",
    sample_collection: "Sample collection",
    fin_operation_commercial_offer: "Fin. operation of Commercial offers",
    forwarding_service_report: "Report by forwarding service"
};
